var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg09(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#ECADA6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_391_462",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_391_462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 35C22.6833 34.4167 20.771 33.0873 19.263 31.012C17.7543 28.9373 17 26.6333 17 24.1V18L25 15L33 18V24.1C33 26.6333 32.246 28.9373 30.738 31.012C29.2293 33.0873 27.3167 34.4167 25 35Z",
    fill: "#ECADA6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg09);
export default __webpack_public_path__ + "static/media/09.fdc692ec43eccee09c3c5cf01168de81.svg";
export { ForwardRef as ReactComponent };